import { getStore } from "assets/commonjs/storage";
import user from "assets/commonjs/userInfo"
export const Utils = {

  // 格式化日期工具
  formatDate(data, fmt) {
    const o = {
      // 'y+': data.getFullYear() + 1,                 // 月份
      'M+': data.getMonth() + 1, // 月份
      'd+': data.getDate(), // 日
      'h+': data.getHours(), // 小时
      'm+': data.getMinutes(), // 分
      's+': data.getSeconds(), // 秒
      'q+': Math.floor((data.getMonth() + 3) / 3), // 季度
      S: data.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (`${data.getFullYear()}`).substr(4 - RegExp.$1.length));
    }
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)));
      }
    }
    return fmt;
  },
  listToObjArr(list) {
    var obj = {};
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      if (!obj[item]) {
        obj[item] = [item];
      } else {
        obj[item].push(item);
      }
    }
  },

  isEmpty(str){
      return str==null||str==="";
  },
  getDateDiff(dateTimeStamp){
    let result;
    var minute = 1000 * 60;
    var hour = minute * 60;
    var day = hour * 24;
    var month = day * 30;
    var now = new Date().getTime();
    var diffValue = now - dateTimeStamp;
    if(diffValue < 0){return;}
    var monthC =diffValue/month;
    var weekC =diffValue/(7*day);
    var dayC =diffValue/day;
    var hourC =diffValue/hour;
    var minC =diffValue/minute;
    if(monthC>=1){
      result="" + parseInt(monthC) + "月前";
    }
    else if(weekC>=1){
      result="" + parseInt(weekC) + "周前";
    }
    else if(dayC>=1){
      result=""+ parseInt(dayC) +"天前";
    }
    else if(hourC>=1){
      result=""+ parseInt(hourC) +"小时前";
    }
    else if(minC>=1){
      result=""+ parseInt(minC) +"分钟前";
    }else
    result="刚刚";

    return result;
  },
  getDateTimeStamp(dateStr){
    return Date.parse(dateStr.replace(/-/gi,"/"));
   },
     /**
     * 判断设备 处理app产品跳转详情页面
     * @returns {number}
     */
    mechined () {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; // android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      if (isAndroid) return 0;
      if (isiOS) return 1;
      else return -1;
  },
  getUrlData:function(){
    //得到浏览器url地址#后的字符串（httt://../../..#..）
   
    var type = window.location.search.substring(1);
   
    return type;
},
userIpInfo() {
  let userSource, userDevice, userIpInfo;
  if (
    getStore("noneheader") != "" &&
    getStore("noneheader") != undefined &&
    getStore("noneheader") != null
  ) {
    userSource = "App";
  } else {
    userSource = "M站";
  }
  if (user.mechined() == 0) {
    userDevice = "Android";
  } else if (user.mechined() == 1) {
    userDevice = "IOS";
  } else {
    userDevice = "PC";
  }
  userIpInfo = {
    userSource: userSource,
    userDevice: userDevice,
    userDeviceDetail: navigator.userAgent
  };
  return userIpInfo
},


};
export default Utils

export const getQueryString =(name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = decodeURI(window.location.search.substr(1)).match(reg);
  if (r != null)return unescape(r[2]);
  return null;
}
// js生成uuid唯一标识
export const guid = () => {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}
/**
 * 清除html多余代码
 *  排除表情,去除其他所有html标签
 * @param msg
 * @returns {XML|string|void}
 */

export const clearMsgHtml = (msg) => {
  // var msg = msg.replace(/((^((&nbsp;)+))|\n|\t|\r)/g, '').replace(/<\/?(?!(img|IMG)\s+src="[^>"]+\/face\/[^>"]+"\s*>)[^>]*>/g, '');
  var msg = msg.replace(/((^((&nbsp;)+))|\n|\t|\r)/g, '')
  if (msg) {
    msg = msg.trim()
  }
  return msg
}

/**
 * 空判断
 * @param v
 * @returns {boolean}
 */
export const isBlank = (v) => {
  return v == undefined || v == null || v == 'undefined' || v == 'null'
}
